/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  RunLcaOnProductsMutationRequest,
  RunLcaOnProductsMutationResponse,
} from "../types/RunLcaOnProducts.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const runLcaOnProductsMutationKey = () =>
  [{ url: "/v1/lca/run-lca-on-products" }] as const

export type RunLcaOnProductsMutationKey = ReturnType<
  typeof runLcaOnProductsMutationKey
>

/**
 * @summary Run LCA on products
 * {@link /v1/lca/run-lca-on-products}
 */
export async function runLcaOnProducts(
  data: RunLcaOnProductsMutationRequest,
  config: Partial<RequestConfig<RunLcaOnProductsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    RunLcaOnProductsMutationResponse,
    ResponseErrorConfig<Error>,
    RunLcaOnProductsMutationRequest
  >({
    method: "PUT",
    url: `/v1/lca/run-lca-on-products`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function runLcaOnProductsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<RunLcaOnProductsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = runLcaOnProductsMutationKey()
  return mutationOptions<
    ResponseConfig<RunLcaOnProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RunLcaOnProductsMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return runLcaOnProducts(data, config)
    },
  })
}

/**
 * @summary Run LCA on products
 * {@link /v1/lca/run-lca-on-products}
 */
export function useRunLcaOnProducts<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<RunLcaOnProductsMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: RunLcaOnProductsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<RunLcaOnProductsMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? runLcaOnProductsMutationKey()

  const baseOptions = runLcaOnProductsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<RunLcaOnProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RunLcaOnProductsMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<RunLcaOnProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RunLcaOnProductsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<RunLcaOnProductsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RunLcaOnProductsMutationRequest },
    TContext
  >
}
